/** @format */

import React from 'react';
import { Layout } from 'features/layout';
import { CustomersDirectoryContainer } from 'features/customer-profile';

const CustomerDirectoryPage: React.FC = () => {
  return (
    <Layout>
      <CustomersDirectoryContainer />
    </Layout>
  );
};

export default CustomerDirectoryPage;
